import { IoTSelectV2 } from '@frontend/iot/select';
import { ProductSelectV2 } from '@frontend/product/select';
import { SpotSelectV2 } from '@frontend/spot/select';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

const AccountSelect = React.lazy(() => import('@frontend/account/select').then((module) => ({ default: module.AccountSelect })));

const ID = 'role-asset-select';
export interface EntityByTypeSelectProps {
    required?: boolean;
    submitted: boolean;
    type: string;
    onChange: (value: string) => void;
    value: any;
    dispatch: ThunkDispatch<any, any, Action>;
    className?: string;
    isClearable?: boolean;
    useConditionedStyling?: boolean;
}

export const EntityByTypeSelect = (props: EntityByTypeSelectProps) => {
    return (
        <div
            id={ID}
            className={props.className ?? ''}>
            {props.type === 'account' && (
                <AccountSelect
                    {...props}
                    required={props.required ?? true}
                    label='Item (account)'
                    submitted={props.submitted}
                    onChange={(val) => props.onChange(val || '')}
                    value={props.value}
                    allowURLChange={false}
                    className=''
                />
            )}

            {props.type === 'spot' && (
                <SpotSelectV2
                    {...props}
                    required={props.required ?? true}
                    label='Item (spot)'
                    onChange={(val) => props.onChange(val || '')}
                    value={props.value}
                    allowURLChange={false}
                    className=''
                />
            )}

            {props.type === 'iot' && (
                <IoTSelectV2
                    {...props}
                    required={props.required ?? true}
                    label='Item (driver)'
                    onChange={(val) => props.onChange(val || '')}
                    value={props.value}
                    allowURLChange={false}
                    className=''
                />
            )}

            {props.type === 'product' && (
                <ProductSelectV2
                    {...props}
                    required={props.required ?? true}
                    onChange={(val) => props.onChange(val || '')}
                    value={props.value}
                    allowURLChange={false}
                />
            )}

            {/*props.type === 'user' && (
                <UserSelect
                    required
                    label='Item (user)'
                    submitted={props.submitted}
                    onChange={(val) => props.onChange(val || '')}
                    value={props.value}
                />
            )}

            {props.type === 'rakinda' && (
                <RakindaSelect
                    required
                    label='Item (rakinda)'
                    submitted={props.submitted}
                    onChange={(val) => props.onChange(val || '')}
                    value={props.value}
                />
            )}
            {props.type === 'terminal' && (
                <TerminalSelect
                    required
                    label='Item (terminal)'
                    submitted={props.submitted}
                    onChange={(val) => props.onChange(val || '')}
                    value={props.value}
                />
            )}
            {props.type === 'transaction' && (
                <TransactionSelect
                    required
                    label='Item (transaction)'
                    submitted={props.submitted}
                    onChange={(val) => props.onChange(val || '')}
                    value={props.value}
                />
            )*/}
        </div>
    );
};
